import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET
} from "../../constants/ActionTypes";
import axios, { apiUrl } from '../../util/Api';
import API_ENDPOINTS from "../../util/apiEndpoints";
import { startGuestSession as openGuestSession, isGuest } from "../../util/guestMode";
// const jwt = require('jsonwebtoken'); // decode'a ihtiyacın yok, backend user döndürüyor

export const setInitUrl = (url) => ({ type: INIT_URL, payload: url });

const readStorageItem = (key) => {
  if (typeof window === "undefined") return null;
  const sessionValue =
    typeof sessionStorage !== "undefined" ? sessionStorage.getItem(key) : null;
  if (sessionValue !== null) return sessionValue;
  return localStorage.getItem(key);
};

const clearActiveStorage = () => {
  if (typeof window === "undefined") return;
  const hasSessionToken =
    typeof sessionStorage !== "undefined" && sessionStorage.getItem("token");
  if (hasSessionToken) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
  } else {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }
};

/**
 * MİSAFİR OTURUMU AÇ — sayfa açılışında, giriş yapmamış ziyaretçi için.
 * Sunucu geçici ama gerçek bir hesap (tenant + kullanıcı + ücretsiz plan)
 * döndürür; ziyaretçi ürünü kabuğundan değil içinden kullanır.
 */
export const guestSignIn = () => {
  return (dispatch) => {
    return openGuestSession(axios).then((session) => {
      if (session && session.token && session.user) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + session.token;
        dispatch({ type: USER_TOKEN_SET, payload: session.token });
        dispatch({ type: USER_DATA, payload: session.user });
        return session.user;
      }
      return null;
    });
  };
};

/**
 * MİSAFİR HESABINI KALICIYA ÇEVİR (claim).
 * Kayıt formu misafirken gönderilirse yeni tenant açılmaz; misafirken kurulan
 * her şey aynı tenantta kalır, hesap sahiplendirilir ve oturum devam eder.
 */
export const claimGuestAccount = (payload) => {
  return (dispatch) => {
    return axios
      .post(API_ENDPOINTS.guest.claim, payload)
      .then(({ data }) => {
        const user = persistSession(dispatch, data);
        if (user) return { success: true, claimed: true, user, message: data.message };
        return {
          error: data?.error || "claim_failed",
          message: data?.message || "Hesap oluşturulamadı.",
          missing_fields: data?.missing_fields,
        };
      })
      .catch((error) => ({
        error: error?.response?.status || "network",
        message: error?.response?.data?.message || error?.message || "Ağ hatası oluştu.",
        missing_fields: error?.response?.data?.missing_fields,
      }));
  };
};

export const userSignUp = ({email, password, full_name, company_name, contact_number, referral_code, affiliate_code, sector}) => {
  return (dispatch) => {
    /* Ziyaretçi misafir oturumundaysa kayıt YENİ hesap açmaz — denerken
       kurduğu tenantı sahiplendirir. Yoksa kurduğu her şey çöpe giderdi. */
    if (isGuest()) {
      return claimGuestAccount({
        email,
        password,
        full_name,
        company_name,
        contact_number,
        referral_code,
        affiliate_code,
        sector,
      })(dispatch);
    }
    return axios
      .post(API_ENDPOINTS.auth.register, {
        email,
        password,
        full_name,
        company_name,
        timezone: "Europe/Istanbul",
        contact_number,
        referral_code,
        affiliate_code,
        sector,
      })
      .then(({data}) => {
        if (data && (data.error === 0 || data.error === false)) {
          return {success: true, message: data.message || "Kayıt başarılı"};
        }
        return {
          error: data?.error || "register_failed",
          message: data?.message || "Kayıt sırasında bir hata oluştu.",
          missing_fields: data?.missing_fields,
        };
      })
      .catch((error) => {
        const serverMessage = error?.response?.data?.message;
        const statusCode = error?.response?.status;
        return {
          error: statusCode || "network",
          message: serverMessage || error?.message || "Ağ hatası oluştu.",
          missing_fields: error?.response?.data?.missing_fields,
        };
      });
  };
};

const persistSession = (dispatch, data) => {
  if (data && data.error === 0 && data.token && data.user) {
    /* ÖNCE sessionStorage TEMİZLENİR.
       util/Api.js her istekte ÖNCE sessionStorage'a bakıyor, oraya token
       yalnız süper admin "kullanıcı olarak gör" akışında yazılıyor
       (src/index.js). O sekmede sonradan normal giriş yapılınca yeni token
       localStorage'a yazılıyor ama istekler hâlâ ESKİ kimliği taşıyordu:
       giriş "başarılı" görünüp panel yanlış hesabı açıyor ya da 401 alıyordu. */
    try {
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
      }
    } catch (e) { /* özel sekmede depo kapalı olabilir */ }
    localStorage.setItem("token", JSON.stringify(data.token));
    localStorage.setItem("user", JSON.stringify(data.user));
    axios.defaults.headers.common["Authorization"] = "Bearer " + data.token;

    dispatch({ type: USER_TOKEN_SET, payload: data.token });
    dispatch({ type: USER_DATA, payload: data.user });
    return data.user;
  }
  return null;
};

const mapLoginError = (data) => {
  if (data?.error === 102) {
    return { error: "wrong", message: "Email veya şifre hatalı." };
  }
  if (data?.error === 500) {
    return { error: "server", message: "Server error." };
  }
  return { error: data?.error || "login_failed", message: data?.message || "Login failed." };
};

const mapNetworkError = (error) => {
  /* HANGI ADRESE ULASILAMADI — bunu yazmak teshisi dakikalara indiriyor.
     Eskiden yalniz axios'un "Network Error" metni gosteriliyordu; kullanici
     da destek de "internetim var, neden olmuyor?" diye donuyordu. Oysa sebep
     API adresinin kapali/yanlis olmasiydi. */
  const teknik = error?.message || "Network error.";
  return {
    error: "network",
    message: `${teknik} (${apiUrl})`,
  };
};

const signInWithEndpoint = (endpoint) => ({ email, password }) => {
  return (dispatch) => {
    return axios.post(endpoint, { email, password })
      .then(({ data }) => {
        const user = persistSession(dispatch, data);
        if (user) {
          return user;
        }
        return mapLoginError(data);
      })
      .catch((error) => {
        if (error?.response?.data) {
          return mapLoginError(error.response.data);
        }
        return mapNetworkError(error);
      });
  };
};

export const userSignIn = signInWithEndpoint(API_ENDPOINTS.auth.loginPanel);
export const userSignInAdmin = signInWithEndpoint(API_ENDPOINTS.auth.login);
export const userSignInSuperAdmin = signInWithEndpoint(API_ENDPOINTS.auth.superAdminLogin);

export const userLoginAs = (user_id, options = {}) => {
  const { persist = true } = options;
  return (dispatch) => {
    return axios
      .post(API_ENDPOINTS.users.loginAs, { user_id })
      .then(({ data }) => {
        if (data && data.error === 0 && data.token && data.user) {
          if (persist) {
            persistSession(dispatch, data);
          }
          return data;
        }
        return mapLoginError(data);
      })
      .catch((error) => {
        if (error?.response?.data) {
          return mapLoginError(error.response.data);
        }
        return mapNetworkError(error);
      });
  };
};

export const userGoogleSignIn = ({ email, name, surname, profile_picture, credential }) => {
  return (dispatch) => {
    return axios
      .post(API_ENDPOINTS.auth.googleLogin, {
        email,
        name,
        surname,
        credential,
        profile_picture,
      })
      .then(({ data }) => {
        const user = persistSession(dispatch, data);
        if (user) {
          return user;
        }
        return mapLoginError(data);
      })
      .catch((error) => {
        return mapNetworkError(error);
      });
  };
};

export const getMe = () => {
  // Backend'te şimdilik /me yok; localStorage'dan redux'a geri yaz
  return (dispatch) => {
    try {
      const rawUser = readStorageItem("user");
      const rawToken = readStorageItem("token");
      const user = rawUser ? JSON.parse(rawUser) : null;
      const token = rawToken ? JSON.parse(rawToken) : null;

      if (token && user) {
        axios.defaults.headers.common['Authorization'] = "Bearer " + token;
        dispatch({ type: USER_TOKEN_SET, payload: token });
        dispatch({ type: USER_DATA, payload: user });
      } else {
        dispatch(userSignOut());
      }
    } catch (e) {
      dispatch(userSignOut());
    }
  };
};

export const userSignOut = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    setTimeout(() => {
      clearActiveStorage();
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: SIGNOUT_USER_SUCCESS });
    }, 200);
  };
};
